import React from "react";

const Home = () => {
  return (
    <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
      <header className="mb-auto">
        <div>
          <img
            src="../logo/Logo.png"
            height="55"
            width="55"
            alt="SearchMe"
            className="mx-auto mb-0"
          />
        </div>
      </header>

      <main className="px-3">
        <h1 className="h1-search fw-bold">
          Search<span className="h1-me">Me</span>
        </h1>
        <p className="lead h1-search fw-bold">
          Connecting local business owners, artisans and service providers to clients.
        </p>
        <div className="px-3 row justify-content-center">
          <a href="https://apps.apple.com/us/app/searchme/id6746272389" className="columns-md">
            <img
              src="../images/appstore_icon.png"
              height="150"
              alt="App Store"
            />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.geevertech.searchme" className="columns-md">
            <img
              src="../images/playstore_icon.png"
              height="170"
              alt="Play Store"
            />
          </a>
        </div>
      </main>

      <footer className="mt-auto h1-search">
        <p>&copy; SearchMe 2026</p>
      </footer>
    </div>
  );
};

export default Home;
